/**
 * @fileoverview POST handler for the "/:app_group_id/braze_docs/search" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdBrazeDocsSearchCacheKeys } from "./constants";
import type {
  PostAppGroupIdBrazeDocsSearchErrors,
  PostAppGroupIdBrazeDocsSearchProps,
  PostAppGroupIdBrazeDocsSearchResult,
} from "./types";

export const postAppGroupIdBrazeDocsSearch = reactQueryMutationAdapter(
  postAppGroupIdBrazeDocsSearchCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdBrazeDocsSearchErrors>()(
    (props: PostAppGroupIdBrazeDocsSearchProps): Promise<PostAppGroupIdBrazeDocsSearchResult> => {
      return fetch(
        `/${props.appGroupId}/braze_docs/search`,
        "POST",
        {
          search_string: props.searchString,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
